const gerar_arquivo_de_turmas = [
  {
    path: "/geracao-de-arquivo-de-turmas",
    redirect: "/geracao-de-arquivo-de-turmas",
    meta: {
      breadCrumb: "Formação de Turmas - Gerar Arquivo de Turmas",
    },
    children: [
      {
        path: "/geracao-de-arquivo-de-turmas",
        name: "geracao-de-arquivo-de-turmas",
        meta: {
          allowedPermissions: ["turma_gerar_arquivo_csv"],
        },
        component: () =>
          import(
            "@/views/GeracaoDeArquivoDeTurmas/GeracaoDeArquivoDeTurmas.vue"
          ),
      },
    ],
  },
];

export { gerar_arquivo_de_turmas };
